export enum FileContext {
  SEARCH_HEADER = 'searchHeader',
}

export type UploadSearchHeaderImagePayload = {
  image: File;
  context: FileContext;
  metadata: string;
};

export type DeleteFilePayload = {
  context: FileContext;
  metadata: string;
};
